import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress
          variant='determinate'
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' sx={{ color: 'text.secondary' }}>
          {`${Math.round(props?.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function LinearWithValueLabel({ value }) {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    setProgress(value);
  }, [value]);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}
LinearWithValueLabel.defaultProps = {
  value: 0,
};

LinearWithValueLabel.propTypes = {
  value: PropTypes.number,
};

LinearProgressWithLabel.defaultProps = {
  value: 0,
};

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number,
};
